const buildFetchDataPostResult = (response, data, fetchError) => {
    const retryAfterHeader = response.headers.get('Retry-After');
    const retryAfter = typeof retryAfterHeader === 'string'
        && /^\d+$/.test(retryAfterHeader.trim())
        ? Number.parseInt(retryAfterHeader, 10)
        : null;

    return {
        error: fetchError
            ? 'Ошибка отправки данных'
            : !response.ok
                ? data.message
                : '',
        data,
        status: response.status,
        retryAfter: Number.isInteger(retryAfter) && retryAfter > 0 ? retryAfter : null,
    };
};

const buildFetchDataPostTransportFailure = () => ({
    error: 'Ошибка отправки данных',
    status: null,
    retryAfter: null,
});

module.exports = {
    buildFetchDataPostResult,
    buildFetchDataPostTransportFailure,
};
